/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");

require('./general-topic-add.scss');
const template = require('../../community/topic-add.tpl');
const topicAddMixin = require('../../community/topicAddMixin');

const generalTopicAdd = {
  mixins:[topicAddMixin],
  name: "general-topic-add",
  template,
  data() {
    return {
      type:1
    }
  }

}

module.exports = generalTopicAdd;



// WEBPACK FOOTER //
// ./src/appBackend/components/page/community/general-topic/general-topic-add/general-topic-add.js